import React, { useState } from 'react';
import SelectBox from '@components/form/SelectBox';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';
import PropTypes from 'prop-types';

const limit = 10;

const propTypes = {
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  multiple: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  customFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]),
};

const defaultProps = {
  editable: true,
  isRequired: false,
  multiple: false,
  hasError: false,
  onChange: () => {},
  customFilter: {},
  value: '',
  label: '',
};

const RoleSearch = (props) => {
  const {
    editable = true,
    isRequired = false,
    multiple = false,
    hasError = false,
    customFilter = {},
    value = '',
  } = props;

  const [loading, setLoading] = useState({
    initial: false,
    loadMore: false,
  });
  const [options, setOptions] = useState([]);
  const [skip, setSkip] = useState(0);

  const getRoles = useApi(MsAccount.getRoles);

  const onSearch = async (val, newSkip = 0) => {
    if (newSkip) {
      setLoading({ ...loading, loadMore: true });
    } else {
      setLoading({ ...loading, initial: true });
    }
    try {
      let filter = {
        is_active: true,
      };
      if (customFilter && Object.keys(customFilter).length) {
        filter = {
          ...filter,
          ...customFilter,
        };
      }
      if (val) {
        filter.name = { $regex: val, $options: 'i' };
      }
      if (!val && filter.name) {
        delete filter.name;
      }
      const response = await getRoles.request({
        params: {
          filter: filter,
          skip: newSkip,
          limit: limit,
          sort: 'name',
        },
      });
      if (response.status == 200 && response?.data?.data?.length) {
        const result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          if (item.description) {
            item.name = item.description;
          }
          return item;
        });
        if (newSkip) {
          setOptions(options.concat(result));
        } else {
          setOptions(result);
        }
      } else {
        if (!newSkip) {
          setOptions([]);
        }
      }

      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    } catch (error) {
      if (newSkip) {
        setLoading({ ...loading, loadMore: false });
      } else {
        setLoading({ ...loading, initial: false });
      }
    }
  };

  return (
    <SelectBox
      label={props.label ? props.label : 'Role'}
      options={options}
      value={value}
      placeholder={
        loading.initial || loading.loadMore ? 'Loading...' : 'Select Role'
      }
      trackBy="code"
      labelKey="name"
      isRequired={isRequired}
      multiple={multiple}
      editable={editable && !loading.initial}
      hasError={hasError}
      loading={loading.initial}
      loadingCallback={loading.loadMore}
      withCallback
      withLoadMore
      loadMoreEmpty={skip >= options.length}
      searchCallback={(val) => {
        setSkip(0);
        onSearch(val);
      }}
      onLoadMore={(val) => {
        const newSkip = skip + 10;
        setSkip(newSkip);
        onSearch(val, newSkip);
      }}
      onChange={(val) => {
        props.onChange(val);
      }}
      onReady={() => {
        setSkip(0);
        onSearch();
      }}
    />
  );
};

RoleSearch.propTypes = propTypes;
RoleSearch.defaultProps = defaultProps;

export default RoleSearch;
